const ja = {
  here_today_coupon: "本日のクーポンはこちら",
  checkbox: {
    required: "必須",
    optional: "任意",
  },
  btn: {
    refresh: "再読み込み",
    next: "次へ",
    back: "前へ",
    ok: "はい",
    send_response: "回答を送信",
    register: "登録する",
    delete: "削除",
    answer: "回答する"
  },
  calender: {
    incorrect_date_format: "不正な日付フォーマット",
    cannot_set_date_before_min_year: "最小値以前の日付は指定できません",
    today: "今日",
  },
  sample_coupon: "クーポン見本",
  use_coupon: "クーポンを使う",
  terms_and_conditions: "注意事項",
  only_half_width_numeric_characters: "※半角数字のみ",
  only_half_width_alphanumeric_characters: "※半角英数字のみ",
  enter_a_7_digit_number_without_hyphens: "ハイフンなし数字7桁で入力して下さい",
  seven_digit_number_no_hyphens: '数字7桁 (ハイフンなし)'
};
export default ja;
